import moment from "moment";

export const getAgeFromBirthDate = (birthDate: Date | undefined): number => {
  if (!birthDate) return 0;
  return moment().diff(moment(birthDate), 'years');
};

const parseDateValue = (value: Date | string): Date | null => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateDisplay = (value: Date | string | undefined | null): string => {
  if (!value) return "";

  const date = parseDateValue(value);
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatMonthDisplay = (value: Date | string | undefined | null): string => {
  if (!value) return "";

  const date = parseDateValue(value);
  if (!date) return "";

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${year}`;
};

/**
 * Format date as YYYY-MM-DD in local timezone.
 * Avoids UTC shift issues that occur with toISOString().
 */
export const formatDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
